__turbopack_context__.v({
  "container": "knxZIa_container",
  "context": "knxZIa_context",
  "number": "knxZIa_number",
  "sum": "knxZIa_sum",
});
